import i18next, { use } from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';

import { resources } from './locales';
import { ENV_PRODUCTION } from './utilities';

use(LanguageDetector)
    .use(initReactI18next)
    .init({
        resources,
        lng: 'en',
        fallbackLng: 'en',
        debug: !ENV_PRODUCTION,
        // TODO: Why do we not allow nested translation keys?
        keySeparator: false, // we use content as keys
        defaultNS: 'translation',
        interpolation: {
            escapeValue: false,
        },
    });

export default i18next;
